// The products a visitor looked at, most recent first — kept in this browser,
// one list per account (a guest has their own; another account that signs in
// here gets its own list, not the previous one's).
import { useEffect, useState } from "react"
import { getValue } from "aldoo-ra/Value"
import PlatformAuth from "aldoo-ra/PlatformAuth"

const KEY = "aldoo-recently-viewed"
const LIMIT = 20

const owner = () => {
  const auth = getValue("user-credentials", PlatformAuth.persistKey)
  return auth?._id ? String(auth._id) : "guest"
}
const storageKey = () => `${KEY}:${owner()}`

const read = () => {
  try {
    const raw = localStorage.getItem(storageKey())
    const list = raw ? JSON.parse(raw) : []
    return Array.isArray(list) ? list : []
  } catch {
    return []
  }
}

/** Notes a product as viewed (the product page), most recent first. */
export function noteViewed(pid) {
  if (!pid || typeof window === "undefined") return
  try {
    const list = [pid, ...read().filter((p) => p !== pid)].slice(0, LIMIT)
    localStorage.setItem(storageKey(), JSON.stringify(list))
    window.dispatchEvent(new CustomEvent(KEY))
  } catch {}
}

/** The recently viewed pids, most recent first (empty until mounted). */
export function useRecentlyViewed({ except } = {}) {
  const [list, setList] = useState([])
  const [auth] = PlatformAuth.useAuth()
  useEffect(() => {
    const refresh = () => setList(read())
    refresh()
    window.addEventListener(KEY, refresh)
    return () => window.removeEventListener(KEY, refresh)
  }, [auth?._id])
  return except ? list.filter((p) => p !== except) : list
}
